import React from 'react';
import './ITSoftware.css';


function NGOsTrusts() {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/ngos_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>NGOs and Trusts</h1>
          <p>Helping non-profits navigate registrations, compliance, and donor transparency with ease</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Strengthening Social Impact through Structure</h2>
          <p>We help NGOs, societies, and charitable trusts handle 12A, 80G, and FCRA registrations with accuracy.</p>
          <p>Our team guides non-profits on financial reporting, CSR documentation, and income tax exemptions.</p>
          <p>From trust deed drafting to donor receipt audits, we ensure full legal and financial alignment.</p>
          <p>Whether you manage grants, run educational programs, or support rural livelihoods, we bring clarity to your mission.</p>
        </div>
        <div className="content-right">
          <img src="/images/ngos.png" alt="NGOs and Trusts" />
        </div>
      </section>
    </div>
  );
}

export default NGOsTrusts;
